module.exports = "/dist/16ddb1541046ada9b90cacf4adec839a.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-300.woff2
// module id = 149
// module chunks = 0